import { useSortable } from "@dnd-kit/sortable";
import React from "react";
import Select from "react-select";

import { CSS } from "@dnd-kit/utilities";
import {
  CheckIcon,
  CrossIcon,
  DeleteIcon,
  DragAndOrderIcon,
  EditIcon,
  PreviewIcon,
} from "../../../assets/icons";
import { Link } from "react-router";
import constant from "../../../utils/constant";

interface ISortableItemProps {
  testQuestion: any;
  index: number;
  isEdit: boolean;
  isEditIndex: number;
  onEditClick: (testQuestion: any, index: number) => void;
  onEditSubmit: (index: number) => void;
  onCancelClick: (index: number) => void;
  onDeleteTestQuestionClick: (index: number) => void;
  editQuestionHandler: (questionId: number) => void;
  selectedTestQuestion: any;
  handleInlineTestQuestionOnChange: (e: any) => void;
  testEditMode: number;
  Constant: any;
  recommendedStandard: any;
  selectedRecommendedStandard: any;
  handleInlineOnChange: (e: any) => void;
  searchQuestion: any;
  selectedTestQuestionValue: any;
  selectedRecommendedStandardValue: any;
  isEditMode: boolean;
  onPreview: (testQuestion: any) => void;
}

const CannedTestSortableItem: React.FC<ISortableItemProps> = ({
  testQuestion,
  index,
  isEdit,
  isEditIndex,
  onEditClick,
  onEditSubmit,
  onCancelClick,
  onDeleteTestQuestionClick,
  editQuestionHandler,
  selectedTestQuestion,
  handleInlineTestQuestionOnChange,
  testEditMode,
  Constant,
  recommendedStandard,
  selectedRecommendedStandard,
  handleInlineOnChange,
  searchQuestion,
  onPreview,
}: ISortableItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: testQuestion.questionId.toString() + "-" + index });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  // Separate drag handle styles
  const dragHandleStyle = {
    cursor: isDragging ? "grabbing" : "grab",
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
      key={index}
    >
      <td className="px-3 py-2">
        <div
          {...attributes}
          {...listeners}
          style={dragHandleStyle}
          className="inline-flex items-center justify-center"
        >
          <DragAndOrderIcon className="w-6 h-6" />
        </div>
      </td>
      <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
        <p>{testQuestion.orderNumber}</p>
      </td>
      <td className="px-3 py-2  whitespace-nowrap text-sm text-left font-normal text-gray-500">
        {isEditIndex !== index && (
          <a
            href={constant.MANAGEQUESTION.replace(
              ":id",
              testQuestion.questionId.toString()
            )}
            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
            onClick={() => {
              editQuestionHandler(testQuestion.questionId);
            }}
          >
            {testQuestion.questionId}
          </a>
        )}
        {isEdit && isEditIndex === index && (
          <Select
            placeholder=""
            options={searchQuestion}
            theme={(theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: "#B3B3B3",
                primary: "#041E42",
              },
            })}
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "#6B7280"
                    : "#D1D5DB",
                borderWidth: "1px",
                "&:hover": {
                  borderColor:
                    state.isFocused &&
                    document.getElementsByClassName("dark")?.length > 0
                      ? "#6b7280"
                      : state.isFocused
                      ? "#4c5563"
                      : "",
                },
              }),
              singleValue: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "#374051",
              }),
              input: (base) => ({
                ...base,
                color:
                  document.getElementsByClassName("dark")?.length > 0
                    ? "white"
                    : "",
              }),
            }}
            value={selectedTestQuestion}
            isMulti={false}
            onChange={handleInlineTestQuestionOnChange}
          ></Select>
        )}
      </td>
      {testEditMode === Constant.CANNED_TEST_EDIT_MODE.PREMIUM_ASSESSMENT && (
        <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
          {isEditIndex !== index && (
            <p>
              <Link
                to={constant.EDITSTANDARD.replace(
                  ":id",
                  testQuestion.recommendedStandardId
                    ? testQuestion.recommendedStandardId.toString()
                    : ""
                )}
                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
              >
                {
                  recommendedStandard?.filter(
                    (d) => d.value === testQuestion.recommendedStandardId
                  )[0]?.label
                }
              </Link>
            </p>
          )}

          {isEdit && isEditIndex === index && (
            <div className="relative w-full max-w-sm">
              <Select
                placeholder=""
                options={recommendedStandard}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary25: "#B3B3B3",
                    primary: "#041E42",
                  },
                })}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor:
                      document.getElementsByClassName("dark")?.length > 0
                        ? "#6B7280"
                        : "#D1D5DB",
                    borderWidth: "1px",
                    "&:hover": {
                      borderColor:
                        state.isFocused &&
                        document.getElementsByClassName("dark")?.length > 0
                          ? "#6b7280"
                          : state.isFocused
                          ? "#4c5563"
                          : "",
                    },
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color:
                      document.getElementsByClassName("dark")?.length > 0
                        ? "white"
                        : "#374051",
                  }),
                  input: (base) => ({
                    ...base,
                    color:
                      document.getElementsByClassName("dark")?.length > 0
                        ? "white"
                        : "",
                  }),
                }}
                value={selectedRecommendedStandard}
                isMulti={false}
                onChange={handleInlineOnChange}
              ></Select>
            </div>
          )}
        </td>
      )}
      <td>
        <div className="flex items-center ">
          <a onClick={() => onPreview(testQuestion)} className="text-gray-900">
            <PreviewIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
          </a>
        </div>
      </td>
      <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-700">
        <div className="flex gap-3 justify-center">
          {!isEdit && (
            <EditIcon
              title="Edit"
              onClick={() => onEditClick(testQuestion, index)}
              className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
            />
          )}
          {isEdit && isEditIndex === index && (
            <CheckIcon
              onClick={() => onEditSubmit(index)}
              className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
            />
          )}
          {isEdit && isEditIndex === index && (
            <CrossIcon
              title="Cancel"
              onClick={() => onCancelClick(index)}
              className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
            />
          )}
          <DeleteIcon
            onClick={() => onDeleteTestQuestionClick(index)}
            className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
          />
        </div>
      </td>
    </tr>
  );
};

export default CannedTestSortableItem;
